import { useState } from 'react';
import { ChevronDown, ChevronUp, BookOpen } from 'lucide-react';

interface InstructionsProps {
  title?: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export function Instructions({ title = 'How it works', children, defaultOpen = false }: InstructionsProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-[#e5e5e5] rounded-lg bg-[#fafafa] overflow-hidden">
      <button
        type="button"
        className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-[#f5f5f5] transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-2 text-sm font-medium text-[#2b2b2b]">
          <BookOpen className="w-4 h-4 text-[#f26f56]" />
          {title}
        </div>
        <ChevronDown
          className={`w-4 h-4 text-[#807f7e] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && (
        <div className="px-4 pb-4 text-sm text-[#5a5a5a] space-y-3 border-t border-[#e5e5e5] pt-3">
          {children}
        </div>
      )}
    </div>
  );
}

interface StepProps {
  number: number;
  title: string;
  children: React.ReactNode;
}

export function Step({ number, title, children }: StepProps) {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#f26f56] text-white text-xs font-semibold flex items-center justify-center">
        {number}
      </div>
      <div className="pt-px">
        <p className="font-medium text-[#2b2b2b]">{title}</p>
        <p className="text-[#807f7e] text-xs mt-0.5 leading-relaxed">{children}</p>
      </div>
    </div>
  );
}
